// ════════════════════════════════════════════════════════════════════════════
//  features/fiscal/transporte/services/averbacaoService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { MovAverbacaoDto, AverbacaoResultadoDto, AverbarRequest } from '../types';

const BASE = '/api/averbacao';

export const averbacaoService = {
  historico: (pagina = 1, tamanhoPagina = 20, chaveAcesso?: string) =>
    apiClient
      .get<MovAverbacaoDto[]>(`${BASE}/historico`, { params: { pagina, tamanhoPagina, chaveAcesso } })
      .then((r) => r.data),

  obterPorId: (id: number) =>
    apiClient.get<MovAverbacaoDto>(`${BASE}/${id}`).then((r) => r.data),

  averbar: (req: AverbarRequest) =>
    apiClient.post<AverbacaoResultadoDto>(`${BASE}/averbar`, req).then((r) => r.data),

  cancelar: (id: number, motivo: string) =>
    apiClient.post<AverbacaoResultadoDto>(`${BASE}/${id}/cancelar`, { motivo }).then((r) => r.data),
};
